import { CsvButton } from '@components/Buttons/CsvButton';
import { Pagination } from '@components/Table/Pagination';
import { TableKeyCell } from '@components/Table/TableKeyCell';
import { TableLinearLoading } from '@components/Table/TableLinearLoading';
import { TableNoResult } from '@components/Table/TableNoResult';
import { TableSortCell } from '@components/Table/TableSortCell';
import { TableSortRow } from '@components/Table/TableSortRow';
import { TableWrapper } from '@components/Table/TableWrapper';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import ILinha from '@model/Linha';
import { IRelatorioStatusLinhaFilter } from '@services/RelatorioService';
import React from 'react';

export type RelatorioStatusLinhaTableProps = {
    data: IData<ILinha, IRelatorioStatusLinhaFilter>
    isLoading: boolean
    onCsvButtonClick: VoidFunction
}

export function RelatorioStatusLinhaTable ({ data, isLoading, onCsvButtonClick }: RelatorioStatusLinhaTableProps) {
    const formatter = useFormatter();

    return (
        <TableWrapper>
            <TableLinearLoading isLoading={isLoading} />

            <TableNoResult itemCount={data.itemsCount}>
                <TableHead>
                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                    <TableSortRow sort={data.sort}>
                        <TableSortCell fieldName="linhaId">ID</TableSortCell>
                        <TableSortCell fieldName="numeroSemMascara">Número</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraEmpresaNome">Empresa</TableSortCell>
                        <TableSortCell fieldName="contratoOperadoraOperadoraNome">Operadora</TableSortCell>
                        <TableSortCell fieldName="numeroContrato">Número Contrato</TableSortCell>
                    </TableSortRow>
                </TableHead>
                
                <TableBody>
                    {
                        data.items.map((linha, index) => {
                            return (
                                <TableRow key={index}>
                                    <TableKeyCell>{linha.linhaId}</TableKeyCell>
                                    <TableCell>{formatter.toCelular(linha.numeroSemMascara)}</TableCell>
                                    <TableCell>{linha.contratoOperadoraEmpresaNome}</TableCell>
                                    <TableCell>{linha.contratoOperadoraOperadoraNome}</TableCell>
                                    <TableCell>{linha.numeroContrato}</TableCell>
                                </TableRow>
                            )
                        })
                    }

                    <Pagination pagination={data.pagination}>
                        <CsvButton onClick={onCsvButtonClick} disabled={isLoading} />
                    </Pagination>

                </TableBody>
            </TableNoResult>
        </TableWrapper>
    )
}